import Prospect from './Prospect';

export default Prospect;
